module.exports = __webpack_public_path__ + "static/media/Green-check.e0cc71ec.svg";